import { PLAN_OPTIONS } from '../flow/checkboxOptions';
import { MatcherGenericCheckboxStep } from '../components';

function MatcherPlanStep() {
  return (
    <MatcherGenericCheckboxStep
      questionId="plan"
      title="What advice do you need?"
      options={PLAN_OPTIONS}
      stepName="matcher_plan_step"
    />
  );
}

export { MatcherPlanStep };
